import {Component, computed, inject, Injector, OnInit, signal} from "@angular/core";
import {BasicMaterialDialog, MatDialogDataBaseInput} from "../../basic-material-dialog/basic-material-dialog.directive";
import {ExamSession, FetchDataType, FontAwesomeCode, ParticipantType, ScenarioRecording, SimUser} from "@models";
import {FormControl, Validators} from "@angular/forms";
import {SimSessionService} from "@services";
import {EnumLabel} from "../../../../../shared/shared-pipes/enum-label.pipe";

export interface DialogDataExamParticipantDialogInput extends MatDialogDataBaseInput {
	participantType: ParticipantType;
	examSession: ExamSession;
	scenarioRecording: ScenarioRecording;
	preselectedUser: SimUser | null;
}

function computeHeaderIcon(participantType: ParticipantType): FontAwesomeCode {
	const result: FontAwesomeCode = {fontSet: "fad", fontIcon: "fa-user"};
	switch (participantType) {
		case ParticipantType.Learner:
			result.fontIcon = "fa-user-graduate";
			break;
		case ParticipantType.Instructor:
			result.fontIcon = "fa-user-graduate";
			break;
		case ParticipantType.StandardizedPatient:
			result.fontIcon = "fa-user-injured";
	}
	return result;
}

@Component({
	selector: "sim-exam-participant-dialog",
	templateUrl: "./exam-participant-dialog.component.html",
	styleUrl: "./exam-participant-dialog.component.scss",
	standalone: false,
})
export class ExamParticipantDialogComponent
	extends BasicMaterialDialog<ExamParticipantDialogComponent, DialogDataExamParticipantDialogInput>
	implements OnInit
{
	// Constants
	protected readonly FetchDataType = FetchDataType;
	protected readonly EnumLabel = EnumLabel;

	// Properties
	protected readonly participantType = signal<ParticipantType>(this.data.participantType).asReadonly();
	protected readonly busyPromise = signal<Promise<unknown> | undefined>(undefined);
	protected readonly headerIcon = computed<FontAwesomeCode>(() => computeHeaderIcon(this.participantType()));
	protected readonly formCtrl = new FormControl<SimUser | null>(this.data.preselectedUser);

	readonly #sessionService = inject(SimSessionService);

	constructor(_injector: Injector) {
		super(_injector);
	}

	ngOnInit(): void {
		super.ngOnInit();
		if (this.participantType() === ParticipantType.Learner) {
			this.formCtrl.setValidators([Validators.required]);
		}
	}

	public async doSubmit(): Promise<void> {
		if (this.formCtrl.invalid) {
			return;
		}
		const user: SimUser | null = this.formCtrl.value;
		const promise = this.#sessionService.correctAnExamParticipantAfterSessionFinished({
			examSessionId: this.data.examSession.id,
			scenarioRecordingId: this.data.scenarioRecording.id,
			participantType: this.data.participantType,
			/*TODO: make BE allow nulls*/
			participantId: user?.id ?? null,
		});
		this.busyPromise.set(promise);
		await promise;
		this.close();
	}
}
